import { render } from "./quiz-v1.vue?vue&type=template&id=9dd65466"
import script from "./quiz-v1.vue?vue&type=script&lang=js"
export * from "./quiz-v1.vue?vue&type=script&lang=js"

import "./quiz-v1.vue?vue&type=style&index=0&id=9dd65466&lang=sass"

import exportComponent from "../../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__